// src/consent.ts
var CONSENT_VERSION = 1;
var CONSENT_STORAGE_KEY = "donoor-cookie-consent";
var CONSENT_COOKIE_NAME = "donoor-cookie-consent";
var CONSENT_MAX_AGE_SECONDS = 180 * 24 * 3600;
function parseConsent(raw) {
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw);
    if (typeof parsed !== "object" || parsed === null) return null;
    if (parsed.version !== CONSENT_VERSION) return null;
    if (typeof parsed.analytics !== "boolean") return null;
    if (typeof parsed.marketing !== "boolean") return null;
    return {
      analytics: parsed.analytics,
      marketing: parsed.marketing,
      timestamp: typeof parsed.timestamp === "string" ? parsed.timestamp : "",
      version: CONSENT_VERSION
    };
  } catch {
    return null;
  }
}
function readCookieValue(cookieHeader, name) {
  if (!cookieHeader) return void 0;
  for (const morceau of cookieHeader.split(";")) {
    const brut = morceau.trim();
    const separateur = brut.indexOf("=");
    if (separateur === -1) continue;
    if (brut.slice(0, separateur) !== name) continue;
    try {
      return decodeURIComponent(brut.slice(separateur + 1));
    } catch {
      return brut.slice(separateur + 1);
    }
  }
  return void 0;
}
function readConsent() {
  if (typeof document === "undefined") return null;
  const depuisCookie = parseConsent(
    readCookieValue(document.cookie, CONSENT_COOKIE_NAME)
  );
  if (depuisCookie) return depuisCookie;
  let depuisStorage = null;
  try {
    depuisStorage = parseConsent(localStorage.getItem(CONSENT_STORAGE_KEY));
  } catch {
    depuisStorage = null;
  }
  if (depuisStorage) writeConsentCookie(depuisStorage);
  return depuisStorage;
}
function writeConsentCookie(consent) {
  if (typeof document === "undefined") return;
  try {
    const hote = window.location.hostname;
    const estLocal = /^(localhost|127\.|\[?::1)/.test(hote);
    const domaine = estLocal ? "" : "; domain=.donoor.org";
    const secure = window.location.protocol === "https:" ? "; Secure" : "";
    const valeur = encodeURIComponent(JSON.stringify(consent));
    document.cookie = `${CONSENT_COOKIE_NAME}=${valeur}; path=/; max-age=${CONSENT_MAX_AGE_SECONDS}; SameSite=Lax${domaine}${secure}`;
  } catch {
  }
}
function persistConsent(consent) {
  writeConsentCookie(consent);
  try {
    localStorage.setItem(CONSENT_STORAGE_KEY, JSON.stringify(consent));
  } catch {
  }
}
function buildConsent(analytics, marketing) {
  return {
    analytics,
    marketing,
    timestamp: (/* @__PURE__ */ new Date()).toISOString(),
    version: CONSENT_VERSION
  };
}
function hasMarketingConsent(consent) {
  return consent?.marketing === true;
}
function marketingAccordeParDefaut(consent) {
  return consent ? consent.marketing : true;
}
function analyticsAccordeParDefaut(consent) {
  return consent ? consent.analytics : true;
}

export { CONSENT_COOKIE_NAME, CONSENT_MAX_AGE_SECONDS, CONSENT_STORAGE_KEY, CONSENT_VERSION, analyticsAccordeParDefaut, buildConsent, hasMarketingConsent, marketingAccordeParDefaut, parseConsent, persistConsent, readConsent, readCookieValue };
//# sourceMappingURL=consent.js.map
//# sourceMappingURL=consent.js.map